export default {
  user: {
    name: 'Usuarios',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
  checklist: {
    name: 'Checklist',
    list: [
      { value: 'readonly', label: 'Usuario' },
      { value: 'report', label: 'Reportes' },
      { value: 'supervisor', label: 'Supervisor' },
      { value: 'admin', label: 'Administrador' }
    ]
  },
  domain: {
    name: 'Dominios',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
/*  web: {
    name: 'Web',
    list: [
      { value: 'readonly', label: 'Usuario' },
      { value: 'admin', label: 'Administrador' }
    ]
  },*/
  mail: {
    name: 'Correo Electrónico',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
/*  files: {
    name: 'Files',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },*/
  erp: {
    name: 'ERP',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
  solution: {
    name: 'Soluciones',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
  dashboard: {
    name: 'Tablero',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
/*  fleet: {
    name: 'Fleet',
    list: [
      { value: 'readonly', label: 'Usuario' },
      { value: 'admin', label: 'Administrador' }
    ]
  },
  iot: {
    name: 'IoT',
    list: [
      { value: 'readonly', label: 'Usuario' },
      { value: 'admin', label: 'Administrador' }
    ]
  }, */
  billing: {
    name: 'Facturación',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
  dte: {
    name: 'Facturación electrónica',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
  sale: {
    name: 'Ventas',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
  purchase: {
    name: 'Compras',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
  project: {
    name: 'Proyectos',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
  crm: {
    name: 'CRM',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
  account: {
    name: 'Contabilidad',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
  stock: {
    name: 'Bodega',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  },
  asset: {
    name: 'Activos',
    list: [
      { value: 'admin', label: 'Administrador' },
      { value: 'readonly', label: 'Usuario' }
    ]
  }
}